<script lang="ts">
    import { tweened } from 'svelte/motion'
    /**
     * Progress in 0..1
     */
    export let progress: number

    let animatedProgress = tweened(progress, {
        duration: 50,
    })
    $: $animatedProgress = progress

    export let text: string = ''

    let ax = 50
    let ay = 4

    $: {
        const angle = 2 * Math.PI * ($animatedProgress - 0.25)
        ax = 46 * Math.cos(angle) + 50
        ay = 46 * Math.sin(angle) + 50
    }
</script>

<svg width="100%" viewBox="0 0 100 100">
    {#if progress === 1}
        <circle
            cx="50"
            cy="50"
            r="46"
            stroke-width="3"
            stroke="var(--color-primary)"
            fill="transparent"
        />
    {:else if progress === 0}
        <circle
            cx="50"
            cy="50"
            r="46"
            stroke-width="3"
            stroke="var(--color-gray-dark)"
            fill="transparent"
            opacity={0.4}
        />
    {:else}
        <path
            d="M 50 4 A 46 46 0 {progress > 0.5 ? 0 : 1} 0 {ax} {ay}"
            stroke-width="3"
            class="progress"
            stroke="var(--color-contrast)"
            fill="transparent"
            opacity={0.1}
        />
        <path
            d="M {ax} {ay} A 46 46 0 {progress > 0.5 ? 1 : 0} 0 50 4"
            stroke-width="3"
            class="progress"
            stroke="var(--color-primary)"
            fill="transparent"
        />
    {/if}
    <text
        x="50"
        y="65"
        fill={progress === 0 ? 'var(--color-gray-dark)' : 'var(--color-primary)'}
        font-size="42"
        text-anchor="middle"
        font-weight="900"
        font-family="var(--font-family-headline)">{text}</text
    >
</svg>
